import "./_historique.scss";

import {Status as StatusInterface} from "@/ts/interface/compte";

function Status({status}: {status: StatusInterface}): JSX.Element {
  const statusColorMap: Record<string, "green" | "red" | "orange"> = {
    Annulé: "red",
    "En Attente": "orange",
    "Palier non atteint": "orange",
    Validé: "green",
    "Palier atteint": "green",
  };

  const color: "green" | "red" | "orange" = statusColorMap[status] || "red";
  return <div className={`historique-produit--status ${color}`}>{status}</div>;
}

export default Status;
